var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00001 1.33325C8.90516 1.33325 9.67033 1.89763 9.91628 2.67138L9.94694 2.77825L9.95227 2.80513C10.687 3.19382 11.3132 3.74019 11.7794 4.3995C12.2456 5.05881 12.5386 5.8123 12.6344 6.59825L12.653 6.77763L12.6657 6.95825V8.79013L12.6797 8.87513C12.771 9.33564 13.0427 9.74745 13.4415 10.0295L13.5528 10.1026L13.6608 10.1645C14.234 10.4689 14.0341 11.2683 13.4095 11.3295L13.3322 11.3333H2.66779C1.9826 11.3333 1.74332 10.4808 2.3392 10.1645C2.59316 10.0297 2.81259 9.84448 2.98209 9.62173C3.15158 9.39899 3.26703 9.14416 3.32032 8.87513L3.33432 8.78575L3.33499 6.9295C3.37563 6.11318 3.62903 5.31863 4.07302 4.61542C4.51701 3.9122 5.13805 3.32176 5.88179 2.89575L6.04709 2.8045L6.05375 2.77763C6.14804 2.40389 6.36232 2.06628 6.66768 1.81034C6.97304 1.5544 7.35479 1.39246 7.76139 1.34638L7.8827 1.33575L8.00001 1.33325Z",
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.38085 12.3333C9.91525 12.3333 10.1976 13.0159 9.84112 13.4453C9.60954 13.7249 9.32581 13.9486 9.00853 14.1016C8.69124 14.2546 8.34757 14.3336 8.00003 14.3333C7.65249 14.3336 7.30882 14.2546 6.99153 14.1016C6.67425 13.9486 6.39052 13.7249 6.15895 13.4453C5.81791 13.0346 6.06133 12.3926 6.55064 12.3379L6.6186 12.3339L9.38085 12.3333Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/Notifications.60c8383b0885b238268730439a029e8b.svg";
export { ForwardRef as ReactComponent };